import { Injectable } from "@angular/core";
import { BasePrimaryActionService } from "./BasePrimaryActionService";
import { ITradeDealActionService } from "../ITradeDealActionService";
import { Subject } from "rxjs";
import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

export abstract class TradeDealPromiseActionService
  extends BasePrimaryActionService
  implements ITradeDealActionService
{
  constructor() {
    super();
  }

  abstract confirmTrade(dealId: string, action: CubiqTS.TradeActionType): Promise<any>;
  abstract confirmTrades(dealId: Array<string>, action: CubiqTS.TradeActionType): Promise<any>;
  abstract cancelTrade(dealId: string, action: CubiqTS.TradeActionType): Promise<any>;
  abstract cancelTrades(dealIds: Array<string>, action: CubiqTS.TradeActionType): Promise<any>;
  abstract addFillComment(
    dealId: string,
    action: CubiqTS.TradeActionType,
    comment: string,
  ): Promise<any>;
  abstract getModelNotificationFailureEventSubject(): Subject<CubiqTS.ConcreteEncodable>;
}
